import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../utils/api';

export default function PolicyPage() {
  const { type } = useParams();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/policies/${type}`).then(({ data }) => setPolicy(data.policy)).finally(() => setLoading(false));
  }, [type]);

  const titles = { rules: 'Rules & Regulations', cashout: 'Cashout Rules' };

  return (
    <div style={{ paddingTop: 70 }}>
      <div className="page-header">
        <h1>{policy?.title || titles[type] || 'Policy'}</h1>
      </div>
      <div className="container" style={{ paddingBottom: 80, maxWidth: 820 }}>
        {/* Breadcrumb */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 28, fontSize: 13, color: 'var(--text-muted)' }}>
          <Link to="/" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Home</Link>
          <span>›</span>
          <span style={{ color: 'var(--text-primary)' }}>{titles[type]}</span>
        </div>

        {loading ? <div className="loading-spinner"><div className="spinner" /></div> : (
          <div>
            {policy?.content && (
              <div style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 12, padding: '18px 22px', marginBottom: 24, fontSize: 15, color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                {policy.content}
              </div>
            )}

            {(policy?.sections || []).map((section, i) => (
              <div key={i} className="card" style={{ marginBottom: 16, padding: '20px 24px' }}>
                {section.heading && (
                  <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 16, color: '#f5c400', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ width: 26, height: 26, borderRadius: '50%', background: 'var(--gradient-primary)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 900, color: '#0a0900', flexShrink: 0 }}>{i + 1}</span>
                    {section.heading}
                  </h3>
                )}
                {section.body && <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.8, margin: 0 }}>{section.body}</p>}
              </div>
            ))}

            {(!policy?.sections || policy.sections.length === 0) && (
              <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-secondary)' }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
                <p>This policy will be updated soon.</p>
              </div>
            )}

            <div style={{ marginTop: 32, padding: '16px 20px', background: 'var(--bg-secondary)', borderRadius: 10, fontSize: 13, color: 'var(--text-muted)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
              <span>Last updated: {policy?.updatedAt ? new Date(policy.updatedAt).toLocaleDateString() : 'N/A'}</span>
              <div style={{ display: 'flex', gap: 12 }}>
                <Link to="/policy/rules" style={{ color: type==='rules'?'#f5c400':'var(--text-muted)', fontSize: 13, fontWeight: type==='rules'?700:400 }}>Rules & Regulations</Link>
                <span style={{ color: 'var(--border)' }}>|</span>
                <Link to="/policy/cashout" style={{ color: type==='cashout'?'#f5c400':'var(--text-muted)', fontSize: 13, fontWeight: type==='cashout'?700:400 }}>Cashout Rules</Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
